import { Component, OnInit, Input } from '@angular/core';
import { Item } from 'my-lib-sanfelici/my-lib-sanfelici';



@Component({
  selector: 'app-dream-view',
  templateUrl: './dream-view.component.html',
  styleUrls: ['./dream-view.component.scss']
})
export class DreamViewComponent implements OnInit {
@Input() item: Item;
  constructor() { }

  ngOnInit() {
  }

}
